/* src/app/cart/item-print-product/item-print-product.component.scss */
.item-title {
  color: black;
  font-weight: 500;
  font-size: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  overflow: hidden;
}
.item-price {
  color: #949494;
  font-weight: 500;
  font-size: 18px;
}
.item-price span {
  color: black;
}
.item-total {
  font-size: 18px;
}
.product-image {
  object-fit: contain;
  border-radius: 5px;
  height: 100%;
}
.stock-error {
  color: red;
}
svg {
  width: 20px;
  height: 20px;
}
svg.danger {
  fill: var(--ion-color-danger);
}
.presale-tag {
  background-color: var(--ion-color-danger);
  color: white;
  border-radius: 6px;
  letter-spacing: 0.2px;
  padding: 5px;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  width: fit-content;
}
.info-part {
  max-width: 200px;
}
.right-part {
  width: 200px;
}
.right-part ion-button::part(native) {
  padding: 0;
}
app-qty-stepper {
  margin-right: 40px;
}
.item-container {
  border: 1px solid #cbcbcb;
  padding: 10px;
  border-radius: 10px;
}
.view-details-button {
  --color: black;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  min-height: auto;
}
.view-details-button::part(native) {
  padding: 3px 5px 3px 5px;
}
.view-details-button img {
  width: 13px !important;
  height: 15px !important;
}
.printing-details {
  background-color: #f6f6f6;
  border-radius: 5px;
  padding: 10px;
}
.hidden-printing-details {
  display: none !important;
}
.file-alias {
  font-size: 16px;
  font-weight: 400;
  border-radius: 5px;
  padding: 5px;
  background-color: #f6f6f6;
}
.file-alias ion-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.file-img {
  width: 28px;
  height: 38px;
}
.ring-img {
  width: 15px;
  height: 15px;
}
.cover-img {
  width: 15px;
  height: 20px;
}
.file-text {
  font-size: 14px;
  font-weight: 400;
}
.edit-folder-button {
  color: white;
  font-size: 14px;
  font-weight: 500;
  --border-radius: 5px;
  margin: 0;
}
.edit-folder-button img {
  width: 14px;
  height: 14px;
}
.edit-folder-button::part(native) {
  padding: 5px 10px 5px 10px;
}
::ng-deep .delete-folder-modal {
  --border-radius: 30px;
  --padding: 30px;
}
.showQty {
  color: #43c0f6;
  font-family: "League Spartan", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  background-color: #f6f6f6;
  border-radius: 4px;
  padding: 2px 10px 2px 10px;
}
.noStock {
  color: #eb445a;
}
.file-details {
  border-radius: 5px;
  padding: 5px;
  background-color: white;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.2);
}
.front-back-paper {
  font-size: 10px;
  line-height: 12px;
}
.coverTypeIcon {
  height: 25px;
  width: 24px;
}
.annotations-row {
  gap: 5px;
}
.annotations-row > span {
  border-radius: 20px;
  padding: 3px;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 10px;
  line-height: 12px;
  font-weight: 500;
}
.annotations-row > span.blue {
  background-color: #d4ecff;
  color: #259dff;
}
.annotations-row > span.pink {
  color: #c80064;
  background-color: #ffd5eb;
}
.annotations-row > span.yellow {
  color: #d59b00;
  background-color: #fff0c6;
}
.coverTypeSettings {
  gap: 5px;
}
/*# sourceMappingURL=item-print-product.component-32LJWDSA.css.map */
